module.exports = __webpack_public_path__ + "img/lock_screen_wallpaper.24a5d5f8.png";